import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=be9a494a&"
import script from "./orderlist.vue?vue&type=script&lang=js&"
export * from "./orderlist.vue?vue&type=script&lang=js&"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=be9a494a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9a494a')) {
      api.createRecord('be9a494a', component.options)
    } else {
      api.reload('be9a494a', component.options)
    }
    module.hot.accept("./orderlist.vue?vue&type=template&id=be9a494a&", function () {
      api.rerender('be9a494a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/orderlist.vue"
export default component.exports